import React, { PureComponent } from 'react';
import { omit } from 'lodash';
import PropTypes from 'prop-types';

import { timesheetsRoutes } from 'selectors/session';

import Text from 'components/Text';

import cxHelpers from 'util/className';
import { trackUxEvent } from 'util/tracking';
import {
  EVENT_ACTIONS,
  EVENT_CATEGORIES,
  PRODUCT_AREAS,
} from 'util/tracking_constants';

import withNavItemActive from '../../hocs/withNavItemActive';
import withNavItemData from '../../hocs/withNavItemData';
import NavItem from '../NavItem';
import NavItemWithSubNav from '../NavItemWithSubNav';

@withNavItemActive(timesheetsRoutes)
@withNavItemData('timesheets')
@cxHelpers('TimesheetsNavItem')
export default class TimesheetsNavItem extends PureComponent {
  static propTypes = {
    url: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
    hidden: PropTypes.bool,
  };

  handleClick = () => {
    trackUxEvent({
      productArea: PRODUCT_AREAS.NAVIGATION,
      eventCategory: EVENT_CATEGORIES.NAV,
      eventAction: EVENT_ACTIONS.TIMESHEETS_TAB_CLICKED,
    });
  };

  render() {
    const { url, currentRoute, ...props } = omit(this.props, 'whiteText');
    const Component = props.menuItems ? NavItemWithSubNav : NavItem;

    return (
      <Component
        currentRoute={currentRoute}
        {...props}
        href={url}
        onClick={this.handleClick}
        className={this.cx()}
      >
        <Text fs14 i18n="nav_links.timesheets.top_level" />
      </Component>
    );
  }
}
